export const SORTING_VALUES = {
  NEWEST: 'newest',
  OLDEST: 'oldest',
}

export const SORTING_OPTIONS = [
  { label: 'equipments.waitline.sort.newestFirst', value: SORTING_VALUES.NEWEST },
  { label: 'equipments.waitline.sort.oldestFirst', value: SORTING_VALUES.OLDEST },
]

export const DEFAULT_SORTING = SORTING_OPTIONS[0].value
